(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@spinnaker/core"));
	else if(typeof define === 'function' && define.amd)
		define("@spinnaker/docker", ["@spinnaker/core"], factory);
	else if(typeof exports === 'object')
		exports["@spinnaker/docker"] = factory(require("@spinnaker/core"));
	else
		root["@spinnaker/docker"] = factory(root["@spinnaker/core"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__) {
return 